/**
 * BOGOS Bundle Builder - Gift Form
 * Adds gift information fields (From, To, Message) to the bundle builder
 * Button only shows after required fields are filled
 * Auto-scrolls to form when selection made in last step
 */

(function() {
  'use strict';

  // ============ CONFIGURATION ============
  const CONFIG = {
    formTitle: 'Gift Information',
    fromLabel: 'From',
    toLabel: 'To',
    messageLabel: 'Message (optional)',
    fromPlaceholder: 'Your name',
    toPlaceholder: "Recipient's name",
    messagePlaceholder: 'Write a message...',
    requireMessage: false
  };
  // =======================================

  let formInjected = false;
  let hasScrolled = false;

  function init() {
    let attempts = 0;
    const maxAttempts = 60;

    const checkInterval = setInterval(() => {
      attempts++;
      
      const btn = document.querySelector('.bogos-bp-button-add');
      const footer = document.querySelector('.bogos-bp-widget-footer');

      if (btn && footer && !formInjected) {
        clearInterval(checkInterval);
        injectGiftForm(btn, footer);
        watchForLastStep();
      }

      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
      }
    }, 500);
  }

// ============================================
// WATCH FOR SELECTION IN LAST STEP & SCROLL
// ============================================
function watchForLastStep() {
  // Listen for clicks on product items
  document.body.addEventListener('click', function(e) {
    if (hasScrolled) return;

    // Check if they clicked on or inside a product item
    const productItem = e.target.closest(
      '.bogos-bp-product-item, ' +
      '.bogos-bp-product-card, ' +
      '.bogos-bp-product, ' +
      '[class*="bogos-bp-product"]'
    );

    if (!productItem) return;

    // Check if we're on the last step
    const steps = document.querySelectorAll('.bogos-bp-step-item');
    if (!steps.length) return;

    const lastStep = steps[steps.length - 1];
    const isLastStepActive = lastStep.classList.contains('bogos-bp-step-active')
                          || lastStep.classList.contains('active')
                          || lastStep.querySelector('.bogos-bp-step-active');

    if (!isLastStepActive) return;

    hasScrolled = true;

    // Wait for BOGOS to finish updating the UI
    setTimeout(() => {
      const form = document.getElementById('bogos-gift-form-wrapper');
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const fromInput = document.getElementById('bogos-gift-from');
        if (fromInput) {
          setTimeout(() => fromInput.focus(), 600);
        }
      }
    }, 500);
  });
}

  // ============================================
  // INJECT GIFT FORM
  // ============================================
  function injectGiftForm(btn, footer) {
    if (formInjected || document.getElementById('bogos-gift-form-wrapper')) return;
    formInjected = true;

    btn.style.display = 'none';

    const styles = document.createElement('style');
    styles.textContent = `
      #bogos-gift-form-wrapper {
        padding: 20px;
        margin-bottom: 15px;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        background: #fafafa;
      }
      #bogos-gift-form-wrapper .gift-title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      #bogos-gift-form-wrapper .gift-field {
        margin-bottom: 12px;
      }
      #bogos-gift-form-wrapper .gift-field label {
        display: block;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 5px;
        color: #333;
      }
      #bogos-gift-form-wrapper .gift-field input,
      #bogos-gift-form-wrapper .gift-field textarea {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 14px;
        box-sizing: border-box;
        font-family: inherit;
        transition: border-color 0.2s;
      }
      #bogos-gift-form-wrapper .gift-field input:focus,
      #bogos-gift-form-wrapper .gift-field textarea:focus {
        outline: none;
        border-color: #333;
      }
      #bogos-gift-form-wrapper .gift-field textarea {
        min-height: 70px;
        resize: vertical;
      }
      #bogos-gift-form-wrapper .required { color: #e53935; }
    `;
    document.head.appendChild(styles);

    const form = document.createElement('div');
    form.id = 'bogos-gift-form-wrapper';
    form.innerHTML = `
      <div class="gift-title">🎁 ${CONFIG.formTitle}</div>
      <div class="gift-field">
        <label>${CONFIG.fromLabel} <span class="required">*</span></label>
        <input type="text" id="bogos-gift-from" placeholder="${CONFIG.fromPlaceholder}">
      </div>
      <div class="gift-field">
        <label>${CONFIG.toLabel} <span class="required">*</span></label>
        <input type="text" id="bogos-gift-to" placeholder="${CONFIG.toPlaceholder}">
      </div>
      <div class="gift-field">
        <label>${CONFIG.messageLabel}${CONFIG.requireMessage ? ' <span class="required">*</span>' : ''}</label>
        <textarea id="bogos-gift-message" placeholder="${CONFIG.messagePlaceholder}"></textarea>
      </div>
    `;

    footer.insertBefore(form, btn);

    const fromInput = document.getElementById('bogos-gift-from');
    const toInput = document.getElementById('bogos-gift-to');
    const msgInput = document.getElementById('bogos-gift-message');

    function validate() {
      const fromVal = fromInput.value.trim();
      const toVal = toInput.value.trim();
      const msgVal = msgInput.value.trim();
      
      let isValid = fromVal && toVal;
      if (CONFIG.requireMessage) isValid = isValid && msgVal;
      
      btn.style.display = isValid ? '' : 'none';
    }

    fromInput.addEventListener('input', validate);
    toInput.addEventListener('input', validate);
    msgInput.addEventListener('input', validate);

    btn.addEventListener('click', function() { 
      const giftData = {
        from: fromInput.value.trim(),
        to: toInput.value.trim(),
        message: msgInput.value.trim()
      };

      setTimeout(() => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Gift From': giftData.from,
              'Gift To': giftData.to,
              'Gift Message': giftData.message
            }
          })
        }).catch(console.error);
      }, 1500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();